import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../views/Home.vue'
import Dashboard from '../views/Dashboard'
import DashboardIndex from '../views/Dashboard/index'
import Auth from '../views/Auth.vue'
import AuthLogin from '../views/Auth/Login.vue'
import Login from '../views/Login.vue'
import Switplanet from '../views/Dashboard/Switplanet.vue'
import Goldshop from '../views/Dashboard/Goldshop.vue'
import Orders from '../views/Dashboard/Orders.vue'
import Bills from '../views/Dashboard/Bills.vue'
import Documents from '../views/Dashboard/Documents.vue'
import Settlements from '../views/Dashboard/Settlements.vue'
import PromoMaterials from '../views/Dashboard/PromoMaterials.vue'
import Api from '../views/Dashboard/Api.vue'
import Instructions from '../views/Dashboard/Instructions.vue'
import AddMerchant from '@/views/Dashboard/AddMerchant'
import Referrals from '@/views/Dashboard/Referrals'
import More from '@/views/Dashboard/More'
import Page404 from '../views/404.vue'

Vue.use(VueRouter)

export const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/dashboard',
    // name: 'dashboard',
    component: Dashboard,
    children: [
      {
        path: '',
        name: 'dashboard',
        component: DashboardIndex
      },
      {
        path: 'add-merchant',
        name: 'add-merchant',
        component: AddMerchant
      },
      {
        path: 'switplanet',
        name: 'switplanet',
        component: Switplanet
      },
      {
        path: 'goldshop',
        name: 'goldshop',
        component: Goldshop
      },
      {
        path: 'orders',
        name: 'orders',
        component: Orders,
        meta: { sidebar: true }
      },
      {
        path: 'bills',
        name: 'bills',
        component: Bills
      },
      {
        path: 'documents',
        name: 'documents',
        component: Documents
      },
      {
        path: 'settlements',
        name: 'settlements',
        component: Settlements
      },
      {
        path: 'promo-materials',
        name: 'promo-materials',
        component: PromoMaterials
      },
      {
        path: 'api',
        name: 'api',
        component: Api
      },
      {
        path: 'instructions',
        name: 'instructions',
        component: Instructions
      },
      {
        path: 'referrals',
        name: 'referrals',
        component: Referrals
      },
      {
        path: 'more',
        name: 'more',
        component: More
      }
    ]
  },
  {
    path: '/reset-pass',
    redirect: '/auth/login'
  },
  {
    path: '/auth',
    name: 'auth',
    component: Auth,
    children: [
      {
        path: 'login',
        name: 'auth_login',
        component: AuthLogin
      }
      // {
      //   path: 'signup',
      //   name: 'auth_signup',
      //   component: SignUp
      // }
    ]
  },
  {
    path: '/404',
    name: '404',
    component: Page404
  },
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router
